import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { addDefaultGtag } from 'config/helper';

export const useGoogleTagManager = () => {
  const {commonDetailsData, commonDetailsDataLoading} = useSelector(({common}) => common);
  const headerSection = commonDetailsData?.header_section;

  const isInitializedRef = useRef(false);
  const currentGtmIdRef = useRef(null);

  useEffect(() => {
    if (commonDetailsDataLoading) {
      return;
    }

    const defaultGtmId = "G-NDKLCMRWEZ";
    const gtmId = headerSection?.analytic_google_tag_manager_id;

    if (isInitializedRef.current && currentGtmIdRef.current === gtmId) {
      return;
    }

    if (gtmId) {
      console.log('🏷️ GTag Type: CLIENT')
      addDefaultGtag(gtmId);
      isInitializedRef.current = true;
      currentGtmIdRef.current = gtmId;
    } else if (!isInitializedRef.current && headerSection) {
      console.log('🏷️ GTag Type: DEFAULT')
      addDefaultGtag(defaultGtmId);
      isInitializedRef.current = true;
      currentGtmIdRef.current = defaultGtmId;
    }
  }, [commonDetailsDataLoading, headerSection]);
};

